module.exports = __webpack_public_path__ + "img/pencil-blue.511c928b.svg";